export function isFileTypeWildcard(acceptedFileExtensions: string[]): boolean {
  return acceptedFileExtensions.includes('*.*');
}
